import datapoints from '../../../datapoints';
import { FavoritesBitFlagsMasks, setBit } from '../../helpers/favoritesBitFlagsActions';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';

/**
 * Hides the first run experience on the persona header
 */
export default action('markPersonaHeaderFirstRunCompleted')(function hidePersonaHeaderFirstRun() {
    setBit(true, FavoritesBitFlagsMasks.PersonaHeaderFirstRunSeen);

    const userOptions = getUserConfiguration().UserOptions;

    updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['FavoritesBitFlags'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: [`${userOptions.FavoritesBitFlags}`],
            }),
        }),
    ]).catch(error => {
        // In case we cannot update the configuration we don't show the FRE in this session again
        const { name: eventName } = datapoints.UpdateUserConfigurationFailed.datapoint;

        trace.error(eventName + ': ' + error);
    });
});
